// src/api/fetchClientContext.ts
import { supabase } from "@/integrations/supabase/client";

export type ClientRole = "client_admin" | "portfolio_manager" | "viewer";

export type ClientContext = {
  client_id: string;
  client_name: string;
  client_slug: string | null;
  roles: ClientRole[];
};

/**
 * Fetch the current user's client context via RPC.
 * Replaces legacy direct query on client_users table.
 */
export async function fetchClientContext(): Promise<ClientContext | null> {
  const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
  if (sessionError) {
    console.error("[fetchClientContext] session error:", sessionError);
    throw sessionError;
  }

  const session = sessionData?.session;
  if (!session) {
    console.warn("[fetchClientContext] no session");
    return null;
  }

  const { data, error } = await (supabase.rpc as any)("get_user_client_context");

  if (error) {
    console.error("[fetchClientContext] RPC error:", error);
    throw error;
  }

  if (!data || (Array.isArray(data) && data.length === 0)) {
    return null;
  }

  const row = Array.isArray(data) ? data[0] : data;

  return {
    client_id: row.client_id,
    client_name: row.client_name ?? "Client",
    client_slug: row.client_slug ?? null,
    roles: Array.isArray(row.roles) ? row.roles : [],
  };
}
